import React, {Component} from 'react';
import PropTypes from "prop-types";
import Api from "../../utils/Api";
import StaticFunctions from "../../utils/StaticFunctions";
import TableContainer from "../../utils/TableContainer";
import SearchField from "../../utils/SearchField";
import LoadingSplash from "../../globalComponents/LoadingSplash";
import Timeformat from "../../utils/Timeformat";
import {confirmAlert} from "react-confirm-alert";

class OldDataOverviewContainer extends Component {

    static propTypes = {
        baseData: PropTypes.object.isRequired
    };

    constructor(props) {

        super(props);

        this.api = new Api();

        this.state = {
            currentCompany: this.props.baseData.companies.currentCompany,
            requestedOldData: null,
            filteredOldData: null,
        };

        this.translate = this.props.baseData.translate;
        this.userLanguage = this.props.baseData.userData.language;
        this.timeFormats = this.props.baseData.languages.getFormatByLanguage(this.userLanguage);

        this.requestOldChartData = this.requestOldChartData.bind(this);
        this.deleteOldChartData = this.deleteOldChartData.bind(this);
        this.onSearch = this.onSearch.bind(this);
        this.onCancel = this.onCancel.bind(this);

    }

    componentWillMount() {

        this.requestOldChartData();

    }

    requestOldChartData() {

        const params = {
            action: 'getOldChartData',
            currentCompanyId: this.props.baseData.companies.currentCompany.id,
            companyId: this.state.currentCompany.id
        };

        const callback = function(res) {
            if (res) {
                this.setState({
                    requestedOldData: res,
                    filteredOldData: this.getTableData(res),
                });
            }
        }.bind(this);

        this.api.request('AdminFunctions', params, callback);

    }

    deleteOldChartData(row) {

        if (!(row && row.table_name)) return null;

        confirmAlert({
            title: <span style={{color: '#ff5400'}}>{this.translate('deleteOldData')}</span>,
            message: <span style={{color: '#ff5400'}}>{this.translate('deleteOldDataQuestion') + ' "' + row.table_name + '" '}</span>,
            buttons: [
                {
                    label: this.translate('yes'),
                    onClick: () => {
                        const params = {
                            action: 'deleteOldChartData',
                            currentCompanyId: this.props.baseData.companies.currentCompany.id,
                            tableName: row.table_name
                        };

                        const callback = function(res) {
                            this.requestOldChartData();
                        }.bind(this);

                        this.api.request('AdminFunctions', params, callback);
                    }
                },
                {
                    label: this.translate('no'),
                }
            ]
        });

    }

    onSearch(name, value) {

        const tableData = this.getTableData(this.state.requestedOldData);
        const filteredData = StaticFunctions.findSubstringInObjArray(tableData, value);

        this.setState({
            filteredOldData: filteredData
        });

    }

    onCancel() {

        this.setState({
            filteredOldData: this.getTableData(this.state.requestedOldData),
        });

    }

    getTableData(rawData) {

        rawData = (rawData) ? rawData : this.state.currentCompanies;

        const timezone = this.props.baseData.companies.currentCompany.timezone;
        const labelYes = this.translate('yes');
        const labelNo = this.translate('no');
        const rows = [];

        for (let i = 0; i < rawData.length; i++) {
            let rowTemp = rawData[i];

            rowTemp.lastTimestamp = (rowTemp.last_timestamp) ? Timeformat.fromUnix(rowTemp.last_timestamp).getFormatedDate(this.timeFormats.datetime, timezone) : '-';

            rows.push(rowTemp);
        }

        return rows;

    }

    getTableColumns() {

        return [
            {
                key: 'machineId',
                nameKey: 'machineId',
                sortType: 'string'
            },
            {
                key: 'tableName',
                nameKey: 'tableName',
                sortType: 'string'
            },
            {
                key: 'lastTimestamp',
                nameKey: 'lastChange',
                sortType: 'date'
            },
            {
                key: 'options',
                nameKey: 'options',
            }
        ];

    }

    getTableRows() {

        const data = (this.state.filteredOldData) ? this.state.filteredOldData : [];
        const rows = [];

        for (let i = 0; i < data.length; i++) {
            let rowTemp = data[i];

            rows.push({
                machineId: rowTemp.machine_id,
                tableName: rowTemp.table_name,
                lastTimestamp: rowTemp.lastTimestamp,
                options: <div className="tableOptions">
                    <a className="optionDelete" onClick={() => this.deleteOldChartData(rowTemp)} title={this.translate('delete')}>&nbsp;</a>
                </div>,
            });
        }

        return rows;

    }

    render() {

        if (this.state.requestedOldData === null) return <LoadingSplash color={'dark'} />;

        const dataCount = (this.state.filteredOldData) ? this.state.filteredOldData.length : 0;
        const countText = (dataCount === 1) ? this.translate('table') : this.translate('tables');
        const tableColumns = this.getTableColumns();
        const tableRows = this.getTableRows();

        return (
            <div>
                <div className="ma-bo-20 clearfix">
                    <div className="clearfix">
                        <nav>
                            <h1>{this.translate('oldDataTables')}</h1>

                            <SearchField
                                baseData={this.props.baseData}
                                name="searchMachinesOverview"
                                placeholder={this.translate('searching')}
                                styles={{padding: 0}}
                                onSearch={this.onSearch}
                                onCancel={this.onCancel}
                            />
                        </nav>
                    </div>

                    <div className="clearfix">
                        <div className="fll">
                            <p>{dataCount} {countText} {this.translate('found')}.</p>
                        </div>
                    </div>

                    <div className="clearfix">
                        <TableContainer
                            baseData={this.props.baseData}
                            columns={tableColumns}
                            rows={tableRows}
                            fillGaps="-"
                        />
                    </div>
                </div>

                <div className="bottomLinks clearfix">
                    <a className="prewLink" onClick={() => this.props.baseData.pageNavigation('admin')}>{this.translate('backToOverview')}</a>
                </div>
            </div>
        );

    }

}

export default OldDataOverviewContainer;
